import { useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";

import { format } from "date-fns";
import { mask } from "remask";

import AppCard from "../../../../components/appCard";
import { Api } from "../../../../services/api";
import { DataTablePague, DropdownPague } from "../../../../styles/primeReactConfig";

export const LogsystemPage = () => {
  window.document.title = "Relatório de Ações - Pague Direto";

  const toast = useRef();

  // dataTable
  const [logsystemData, setLogsystemData] = useState(null);
  const [loadingLogsystem, setLoadingLogsystem] = useState(true);

  // filtro pesquisa
  const [tipoAcao, setTipoAcao] = useState('todos');
  const [searchReload, setSearchReload] = useState(false);

  const [paginationData, setPaginationData] = useState({
    totalRecords: 0,
    first: 0,
    page: 0,
    rows: 10,
    rowsPerPage: [10, 25, 50]
  })

  //chamada de Api
  useEffect(() => {
    async function load(){
      setLoadingLogsystem(true)
      const limit = paginationData.rows;
      const page = paginationData.page;
  
      const { data } = await Api.post(`/relatorio/logsystem?limit=${limit}&page=${page}`,
        { tipo_acao: tipoAcao }
      );
      // console.log('data,', data)
      setLogsystemData(data.data);
      setLoadingLogsystem(false);
      setPaginationData(prev => ({ ...prev, totalRecords: data.total }))
    }
    load()
  }, [searchReload, paginationData.rows, paginationData.page, paginationData.first])

  //functions
  function onPage(event) {
    setPaginationData(prev => ({
      ...prev,
      first: parseInt(event.first),
      rows: event.rows,
      page: event.page,
    }))
  }

  //formatação
  const formatDate = (dateIso) => {
    return format(new Date(dateIso), 'dd/MM/yyyy HH:mm:ss');
  }

  const formatUsuario = (rowData) => {
    let usuario_nome = rowData.usuario_nome ? rowData.usuario_nome : ' --- '
    return <div>
      {usuario_nome}
    </div>
  }

  const formatDevedorNomeDoc = (rowData) => {
    let devedor_nome = rowData.devedor_nome ? rowData.devedor_nome : ' --- '
    let devedor_documento = rowData.devedor_documento ? rowData.devedor_documento : ' --- '
    return (rowData.devedor_documento &&
      <div>
        {devedor_nome} -- {mask(devedor_documento, ['999.999.999-99', '99.999.999/9999-99'])}
      </div>
    )
  }

  // template
  const optionsAction = [
    { label: 'Todos', value: 'todos' },
    { label: 'Atualização de Parâmetro', value: 'parametros_atualizados' },
    { label: 'Negociação Cancelada', value: 'negociacao_cancelada' },
    { label: 'Negociação Quebrada', value:'negociacao_quebrada'},
    { label: '2ª Via', value: '2_via' },
  ]

  const headerLogsystem = (
    <div className="py-3 px-2 grid gap-4">
      <div>
        <h5 className="font-bold text-xl">Registro de Ações</h5>
      </div>
      <section className="grid md:justify-start justify-center w-full m-0 p-0">
        <label htmlFor="tipo_acao">Tipo de Ação</label>
          <Dropdown
            className=" md:w-[20rem] w-full"
            options={optionsAction}
            value={tipoAcao}
            pt={DropdownPague}
            onChange={(e) => {
              setTipoAcao(e.value);
              setSearchReload(prev => !prev);
              setPaginationData(prev => ({ ...prev, first: 0, page: 0, }))
            }}
            inputid="tipo_acao"
          />
      </section>
    </div>
  )

  return (
    <div className="grid w-full">
      <Toast ref={toast} />
      <AppCard className="card w-full !p-0 overflow-x-auto">
        <DataTable
          value={logsystemData}
          loading={loadingLogsystem}
          header={headerLogsystem}
          totalRecords={paginationData.totalRecords}
          first={paginationData.first}
          rows={paginationData.rows}
          rowsPerPageOptions={paginationData.rowsPerPage}
          pt={DataTablePague}
          onPage={onPage}
          emptyMessage="Nenhuma informação encontrada"
          showGridlines
          paginator
          lazy
        >
          <Column
            header="Usuário"
            bodyClassName="md:text-left text-right"
            body={formatUsuario}
            style={{ minWidth: "8rem" }}
            alignHeader={'center'}
          />
          <Column
            header="Devedor"
            bodyClassName="md:text-left text-right"
            body={(rowData) => formatDevedorNomeDoc(rowData)}
            style={{ minWidth: "8rem" }}
            alignHeader={'center'}
          />
          <Column
            header="Ação"
            field="action"
            bodyClassName="md:text-left text-right"
            style={{ minWidth: "8rem" }}
            alignHeader={'center'}
          />
          <Column
            header="Cobrança"
            field="cobranca_descricao"
            bodyClassName="md:text-left text-right"
            style={{ minWidth: "8rem" }}
            alignHeader={'center'}
          />
          <Column
            header="Data"
            field="ls_timestamp"
            bodyClassName="md:text-center text-right"
            body={(rowData) => formatDate(rowData.created_at)}
            style={{ width: "12rem" }}
            alignHeader={'center'}
          />
        </DataTable>
      </AppCard>
    </div>
  )
}